import { motion } from "framer-motion";
import { MANIFESTO } from "@/data";

const MANIFESTO_BG = "https://images.pexels.com/photos/9616959/pexels-photo-9616959.jpeg";

export default function WhyUs() {
  return (
    <section id="why-us" className="relative py-28 md:py-36" data-testid="why-us">
      <div className="max-w-screen-2xl mx-auto px-6 md:px-12 grid lg:grid-cols-12 gap-12">
        {/* Sticky intro */}
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-28">
            <span className="text-primary text-sm font-semibold tracking-[0.25em] uppercase">Why Qonnect QA</span>
            <h2 className="mt-4 font-heading font-light tracking-tighter text-4xl sm:text-5xl lg:text-6xl leading-[1.02] text-foreground">
              Fewer defects.<br />Less rework.<br />
              <span className="text-primary">Real trust.</span>
            </h2>
            <div className="relative mt-10 overflow-hidden rounded-2xl clip-frame">
              <img src={MANIFESTO_BG} alt="Architect studying blueprints" className="h-72 w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
            </div>
          </div>
        </div>

        {/* Numbered chapters */}
        <div className="lg:col-span-7 flex flex-col">
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className={`py-10 ${i !== MANIFESTO.length - 1 ? "border-b border-white/10" : ""}`}
              data-testid={`manifesto-${m.no}`}
            >
              <div className="flex items-start gap-6 md:gap-10">
                <span className="font-heading text-5xl md:text-7xl font-light text-primary/30 leading-none">{m.no}</span>
                <div>
                  <h3 className="font-heading text-2xl md:text-3xl font-medium tracking-tight text-foreground">{m.title}</h3>
                  <p className="mt-3 text-base text-muted-foreground leading-relaxed max-w-xl">{m.body}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
